import React, { useState } from "react";

import "./stylesDashboardBarChart.css";
import RebetLoader from "../../RebetLoader/RebetLoader";

import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
} from "chart.js";

import { formatNumber } from "chart.js/helpers";
import { Skeleton } from "antd";
import CustomDatePicker from "../../CustomDatePicker/CustomDatePicker";

function DashboardBarChart({
  title = false,
  data,
  display = false,
  headers = [],
  customOptions = false,
  isApiRunning = false,
  setSelected,
  getData,
  dates,
  setDates,
  showCustomDatePicker = false,
}) {
  const [activeIndex, setActiveIndex] = useState(0);

  const handeSetActiveIndex = (title, index) => {
    setActiveIndex(index);
    setSelected(title);
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend
    // ChartDataLabels
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      x: {
        beginAtZero: true,
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      datalabels: {
        display,
        anchor: "end",
        align: "start",
        formatter: (value) => value.toLocaleString(),
        color: "black",
        font: {
          family: "Poppins-regular",
          weight: "bold",
        },
      },
      tooltip: {
        enabled: true,
        mode: "index",
        intersect: false,
        backgroundColor: "#252729",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 15,
        displayColors: true,
        callbacks: {
          label: function (tooltipItem) {
            const label = tooltipItem.dataset.label || "";
            const value = tooltipItem.raw;
            return `${label}: ${formatNumber(value)}`;
          },
        },
      },
    },
  };

  return (
    <div id="key-features-chart">
      <div className="key-features-chart-header">
        <div className="dashboard-line-chart-header">
          {headers.map((kpi, index) => (
            <div
              key={index}
              className={`dashboard-line-chart-kpi ${
                activeIndex === index ? "active" : ""
              }`}
              onClick={() => handeSetActiveIndex(kpi.title, index)}
            >
              <div className="dashboard-line-chart-kpi-title">{kpi.title}</div>
              {isApiRunning ? (
                <div style={{ marginTop: 20 }}>
                  <Skeleton.Button
                    active={1}
                    size={10}
                    shape={"default"}
                    block={false}
                  />
                </div>
              ) : (
                <div className="dashboard-line-chart-kpi-value">
                  {formatNumber(kpi.amount, "en-US", {
                    style: "decimal",
                    maximumFractionDigits: 2,
                  })}
                  <div
                    className={`dashboard-line-chart-kpi-percentage ${
                      kpi.percentage >= 0 ? "up" : "down"
                    }`}
                  >
                    {kpi.percentage > 0
                      ? `▲${kpi.percentage}%`
                      : `▼${kpi.percentage}%`}
                  </div>
                </div>
              )}
            </div>
          ))}
          {title && <h3>{title}</h3>}
        </div>
        {showCustomDatePicker && (
          <CustomDatePicker
            getData={getData}
            dates={dates}
            setDates={setDates}
          />
        )}
      </div>
      {isApiRunning ? (
        <RebetLoader height={"100px"} width={"100px"} />
      ) : (
        <div className="key-features-chart-body">
          <Bar data={data} options={customOptions || options} />
        </div>
      )}
    </div>
  );
}

export default DashboardBarChart;
